export default __webpack_public_path__ + "static/media/icon-x.04fb7948.svg";